import React from 'react'
import dynamic from 'next/dynamic'
import useSeti from '@/hooks/useSeti'
import useBootstrapData from '@/hooks/useBootstrapData'

const FlightsDesktop = dynamic(() => import('./Desktop'))
const FlightsMobile = dynamic(() => import('./Mobile'))

function Flights() {
  useSeti('AA_FLIGHTS_LP') // AA Test: Unconditional firing and no visual changes
  const { isMobile } = useBootstrapData()
  return isMobile ? <FlightsMobile /> : <FlightsDesktop />
}

export default Flights
